import React, { useEffect, useState } from 'react';
import {Badge, ButtonDropdown, SpaceBetween, TopNavigation} from '@amzn/awsui-components-react/polaris';
import logo from "./images/amz_logo_white_small.png"
import { useAuth } from './context/AuthContextProvider';
import { Box } from '@amzn/awsui-components-react';
import { useSelector, useDispatch } from 'react-redux'
import { setCurrentAppAuthorization, setCurrentUserId, setCurrentFullName, setCurrentEmail, setIsPortalAdmin, setLoginRedirectPath, setIsSupportAdmin, setScreenWidth, setCurrentUserLDAPS, setIsCorpReportingAdmin, setIsFirstPassProFullUser} from './store/userAuthSlice'
import checkPageAccess, { checkGeneralAccess, fetchAndCacheAllLdaps, isFirstPassProFullUser } from './checkPageAccess'

import {checkIfPortalAdmin, checkIfSupportAdmin, getCacheKey, getCachedResult} from './checkPageAccess'
import {ACCESS_LEVEL_IDs} from './constants/AppConstants'
import {useHistory} from 'react-router-dom'
import appSettings from './Ateam-BI/CorpReporting/app_settings';
import { Link, useLocation, useParams } from "react-router-dom";
import { BUTTON_LINKS } from './Ateam-BI/CorpReporting/FlexicoConstants';
import { isCorpAdmin } from './Ateam-BI/Templates/Utils/Permissions';



function TopNav() {  

  const userAuthenticationDetails = useAuth();

  const userLDAPS = userAuthenticationDetails.USER_LDAP_GROUPS;
  const userId  = userAuthenticationDetails.Alias;
  const userEmail  = userAuthenticationDetails.Email;
  const userGivenName = userAuthenticationDetails.DisplayName;
  const [width, setWidth] = useState(window.innerWidth);
  const dispatch = useDispatch();
  const currentAppId = useSelector((globalState)=>globalState.auth.currentAppId)
  const currentAppPage = useSelector((globalState)=>globalState.auth.currentAppPage)
  const currentStage = useSelector((globalState)=>globalState.auth.currentStage)
  const isPortalAdmin = useSelector((globalState)=>globalState.auth.isPortalAdmin)
  const isSupportAdmin = useSelector((globalState)=>globalState.auth.isSupportAdmin)
  const currentUser = useSelector((globalState)=>globalState.auth.userId)
  const loginRedirectPath = useSelector((globalState)=>globalState.auth.loginRedirectPath)
  const organization = useSelector((globalState)=>globalState.auth.organization)
  const screenWidth = useSelector((globalState)=>globalState.auth.screenWidth)
  const ln = useLocation()
  const history = useHistory()
  const title = (
    <SpaceBetween direction='horizontal' size='m'>
      <Box variant='h3'> Accounting Central {organization ? <Box>  - {organization} </Box> : <></>}</Box>
      {
        currentStage != 'prod' ? <Badge color="severity-medium">{currentStage}</Badge> : <></>
      }
    </SpaceBetween>
  )
  const reportCRA = (
    <Box>
      {
        currentAppId == appSettings[currentStage]?.appId && <ButtonDropdown
          items={BUTTON_LINKS}
          variant="primary"
        >
          Report An Issue
        </ButtonDropdown>
      }

    </Box>
  )
  
  useEffect(() => {
    dispatch(setCurrentUserId(userId))
    dispatch(setCurrentFullName(userGivenName))
    dispatch(setCurrentEmail(userEmail))
    dispatch(setCurrentUserLDAPS(userLDAPS))
    if(loginRedirectPath && userId) {
      const path = loginRedirectPath;
      dispatch(setLoginRedirectPath(null))
      history.push(path)
    }
  },[]);

  useEffect(() => {
    async function checkPortalAdminUser() {
      if (isPortalAdmin === false || isPortalAdmin === null) {
        const result = await checkIfPortalAdmin(userId, currentStage);
        dispatch(setIsPortalAdmin(result));
      }
    }

    async function checkSupportAdminUser() {
      if (isSupportAdmin === false || isSupportAdmin === null) {
        const result = await checkIfSupportAdmin(userId, currentStage);
        dispatch(setIsSupportAdmin(result));
      }
    }

    async function checkCorpReportingAdminUser() {
      if (isSupportAdmin === false || isSupportAdmin === null) {
        let accessPerms = await isCorpAdmin(userId, appSettings[currentStage].appId, currentStage)
        dispatch(setIsCorpReportingAdmin(accessPerms?.admin));
      }
    }

    async function checkIsFirstPassProFullUser() {
      if (isPortalAdmin === false || isPortalAdmin === null) {
        const result = await isFirstPassProFullUser(userId, currentStage);
        dispatch(setIsFirstPassProFullUser(result));
      }else{
        dispatch(setIsFirstPassProFullUser(true));
      }
    }
    
    
    if (userId && currentStage) {
      checkPortalAdminUser()
      checkSupportAdminUser()
      checkCorpReportingAdminUser()
      checkIsFirstPassProFullUser()
      fetchAndCacheAllLdaps(currentStage)
    }

    
    
  }, [currentUser, currentStage, isPortalAdmin, isSupportAdmin]);
  
    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
    useEffect(()=>{
      dispatch(setScreenWidth(width))
    },[width])

  useEffect(() => {
    
    async function checkUserAuthorizedForApp (){

      if(currentAppId && userId && currentStage) {

      dispatch(setCurrentAppAuthorization(null))
      const params = {userAlias: userId,
         id: currentAppId,
         stage: currentStage
        }
      const result = await checkGeneralAccess(params);
      dispatch(setCurrentAppAuthorization(result))

    }
  }
    
      if(isPortalAdmin) {
        dispatch(setCurrentAppAuthorization(true))
      } else {
          checkUserAuthorizedForApp()
      }
    return () => {
      // this now gets called when the component unmounts
    };
  }, [currentAppId, currentStage, isPortalAdmin]);

  
    return (
      <div id='h'>
        <TopNavigation
          identity={{
            href: currentAppId == appSettings[currentStage]?.appId ? "/CorpReportingHome" : organization ? `/Org/${organization}` : "/",
            title: title,
            logo: {
              src:
                `${logo}`,
              alt: title,
            }
          }}
        utilities={isPortalAdmin ? [
          {
            type: "button",
            text: (reportCRA),
            external: false
          },{
            type: "button",
            text: "Admin panel",
            href: "/Admin",
            iconName: "settings",
            external: false
          },
          {
            type: "menu-dropdown",
            text: `${userGivenName}`,
            description: `${userEmail}`,
            iconName: "user-profile",
            items: []
          },
          {
          
            type:"button",
            text: (
              
            <img
                alt=""
                className="rounded-circle"
                src={'https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=' + userId}
                width={35}
                height={35}
            />          
            ),
             href: 'https://phonetool.amazon.com/users/' + userId,
          },
          {
            type:"button",
            text:(<Box color='text-status-info'>{currentStage === 'prod' ? '' : currentStage}</Box> )
          },
        ]: [
          {
            type: "button",
            text: (reportCRA),
            external: false
          },{
            type: "menu-dropdown",
            text: `${userGivenName}`,
            description: `${userEmail}`,
            iconName: "user-profile",
            items: []
          },
          {
          
            type:"button",
            text: (
              
            <img
                alt=""
                className="rounded-circle"
                src={'https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=' + userId}
                width={35}
                height={35}
            />          
            ),
             href: 'https://phonetool.amazon.com/users/' + userId,
          },
          {
            type:"button",
            text:(<Box color='text-status-info'>{currentStage === 'prod' ? '' : currentStage}</Box> )
          },
        ]}
        i18nStrings={{
          searchIconAriaLabel: "Search",
          searchDismissIconAriaLabel: "Close search",
          overflowMenuTriggerText: "More",
          overflowMenuTitleText: "All",
          overflowMenuBackIconAriaLabel: "Back",
          overflowMenuDismissIconAriaLabel: "Close menu"
        }}
      /> 
    </div>
    );
}

export default TopNav;
